module.exports = __webpack_public_path__ + "static/img/HSIEH_MING-HSUN.jpg";